import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlDatetimeProps extends ControlTemplateProps {

}

export const ControlDatetime: React.FC<ControlDatetimeProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="datetime-local" {...ComponentProps(props)} style={{ ...styles.datetime ?? styles.date ?? styles.text ?? styles.input, ...props.style }} />        
    );
};